<template>
  <div>
    <section class="notifications">
      <div class="notifications__content">
        <header class="notifications__header">
          <h1 v-if="unreadNotifications > 0">{{ unreadNotifications
            }} {{ getTranslations.home_notifications_unread }}</h1>
          <a style="cursor: pointer" @click.stop.prevent="clearData">{{ getTranslations.home_notifications_clear_all }}</a>
        </header>
        <div class="notifications__list">
          <ul v-for="(notificationToday, index) in notificationTodayArrays" :key="index">
            <li :class="[ notificationToday.readStatus ? 'read' : '', notificationToday.notificationCategoryDTO.name === 'Bonus Points' ? 'bonus' : '' ]">
              <div :class="['notifications__list__icon', (notificationToday.notificationCounter > 1)? 'challenge_number_main': '']">
                <img :src="showCorrectImg(notificationToday)" style="cursor: pointer" alt="" @click.prevent="redirectUserToProfile(notificationToday)">
                <div class="challenge_number"><span>{{ notificationToday.notificationCounter }}</span></div>
              </div>
              <div class="notifications__list__text">
                <strong>{{ notificationTranslationMethod(notificationToday.notificationCategoryDTO.name) }}</strong>
                <span v-html="notificationTranslationMethodText(notificationToday)"></span>
                <span>{{ notificationToday.notificationDate | getFormat }}</span>
              </div>
              <div class="notifications__list__button" v-if="notificationsWithoutCheckItButton(notificationToday.notificationCategoryDTO.name)">
                <button class="btn2 btn2--std btn2--small btn2--green"
                        @click.prevent="checkItToday(notificationToday)">
                  {{ getButtonTranslation(notificationToday.notificationCategoryDTO.name) }}
                </button>
              </div>
            </li>
          </ul>
          <div v-for="(notificationBar, index) in notificationArraysBar" :key="'B' +index">
            <div class="notifications__list__seperator">
              <span>{{ notificationBar.notificationDate | getFormatForBar }}</span>
            </div>
            <ul v-for="(notification, index) in notificationArrays" :key="'C' + index"
                v-if="hasTheSameDate(notification.id, notificationBar.notificationDate)">
              <li :class="[ (notification.data.readStatus == true) ? 'read' : '' ]">
                <div :class="['notifications__list__icon', (notification.data.notificationCounter > 1)? 'challenge_number_main': '']">
                  <img style="cursor: pointer" :src="showCorrectImg(notification.data)" alt=""  @click.prevent="redirectUserToProfile(notification.data)">
                  <div class="challenge_number"><span>{{ notification.data.notificationCounter }}</span></div>
                </div>
                <div class="notifications__list__text">
                  <strong>{{ notificationTranslationMethod(notification.data.notificationCategoryDTO.name) }}</strong>
                  <span v-html="notificationTranslationMethodText(notification.data)"></span>
                  <span>{{ notification.data.notificationDate | getFormat }}</span>
                </div>
                <div class="notifications__list__button" v-if="notificationsWithoutCheckItButton(notification.data.notificationCategoryDTO.name)">
                  <button class="btn2 btn2--std btn2--small btn2--green"
                          @click.prevent="checkIt(notification.data)">{{ getButtonTranslation(notification.data.notificationCategoryDTO.name)
                    }}
                  </button>
                </div>
              </li>
            </ul>
          </div>
          <input v-show="extraArraysLength" type="submit" value="···"
                 class="load-more btn2 btn2--std btn2--small btn2--green" @click.prevent="displayMore">
        </div>
      </div>
    </section>
    <component :is="currentNotificationModal"
               v-bind="currentProperties"
               @read="updateReadStatus"
               @close="currentNotificationModal = null"/>
  </div>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }] */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import Vue from 'vue';
import RoundUpMixin from '@/common/mixins/roundUp';
import RequestForRematch from '@/common/mixins/extraRematchInfo';
import ChecksToStartNewGameWithCelebrity from '@/common/mixins/rematch/celebrityMatchValidations';
import LevelUp from './modals/LevelUp';
import BonusDaily from './modals/bonus_phases/BonusDaily';
import PrizeDetails from './modals/prizes/PrizeDetails';
import Ranking from './modals/Ranking';
import ConfirmChallengeRequest from './game/challenge/ConfirmChallengeRequest';
import PointsMultiplier from './modals/bonus_phases/PointsMultiplier';
import BundleDiscount from './modals/bonus_phases/BundleDiscount';
import NewAchievement from './modals/achievements/NewAchievement';
import SpinWheel from './modals/achievements/SpinWheel';
import LootBox from './modals/achievements/LootBox';


const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'notifications',
  components: {
    ConfirmChallengeRequest,
    LevelUp,
    PrizeDetails,
    Ranking,
    BonusDaily,
    NewAchievement,
    SpinWheel,
    LootBox,
  },
  mixins: [RoundUpMixin, RequestForRematch, ChecksToStartNewGameWithCelebrity],
  data() {
    return {
      currentNotificationModal: null,
      currentNotificationData: {},
      showmore: false,
      extraArrays: [],
      userNotifications: [],
      displayNotifications: [],
      displayDifferentDaysNotifications: [],
      displayBlackBar: [],
      unreadNotifications: 0,
      moreNotifications: false,
      hiddenNotificationsNumber: 3,
    };
  },
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line
    console.log('==> inside component\'s beforeRouteEnter:');
    if (process.env.NODE_ENV !== 'production') {
      const deepCloneForStrictError = JSON.parse(JSON.stringify(localStorage.getItem('locale')));
      moment.locale(deepCloneForStrictError);
    } else {
      moment.locale(localStorage.getItem('locale'));
    }
    next();
  },
  created() {
    this.changeNotificationReadStatus().then(() => {
      this.getUserNotifications().then(() => {
        this.numberOfUnreadNotifications();
      });
    });
  },
  mounted() {
    this.numberOfUnreadNotifications();
  },
  updated() {
    this.bindProfileLinListener();
  },
  methods: {
    ...mapActions('users', [
      'searchUsers',
    ]),
    ...mapActions('profile', [
      'changeNotificationReadStatus',
      'getUserNotifications',
      'clearNotifications',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
      'toggleNeedLoad',
    ]),
    ...mapMutations('users', [
      'clearSearchedUsers',
      'setSelectedUser',
    ]),
    ...mapMutations('game', [
      'updateChallengeInfo',
    ]),
    ...mapMutations('profile', [
      'saveBonusDailyModal',
      'setShowmodalForLevelUp',
      'setShowmodalForRanking',
      'setShowmodalForDefaultPrizeDetails',
      'setShowModalForGrandPrize',
      'updatePhaseBonusModalToBeDisplayed',
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationId',
      'setCheckedNotificationReadStatus',
    ]),
    bindProfileLinListener() {
      const clickAction = (event) => {
        this.showUserProfile(event.target.innerHTML);
      };
      this.$nextTick(() => {
        Object.values(document.getElementsByClassName('profileLink'))
          .forEach((link) => {
            link.addEventListener('click', clickAction);
          });
      });
    },
    updateReadStatus() {
      if (this.checkedNotificationId) {
        this.$axios.get(`api/changeNotificationStatus?notificationId=${this.checkedNotificationId}`);
      }
      this.userNotifications = this.notifications;
      this.numberOfUnreadNotifications();
    },
    redirectUserToProfile(notification) {
      // For Play with celebrity notifications do not navigate user to his profile
      if (notification.opponentAvatar && notification.notificationCategoryDTO.name !== 'Play with Celebrity') this.showUserProfile(notification.text);
    },
    showUserProfile(usernameInNotification) {
      this.toggleNeedLoad({ value: true });
      this.searchUsers({ username: usernameInNotification }).then(() => {
        this.toggleNeedLoad({ value: false });
        this.setSelectedUser(usernameInNotification);
        this.$router.push({ name: 'other-user-profile' });
      });
    },
    showCorrectImg(notification) {
      if (notification.opponentAvatar) {
        // For Play with celebrity notifications we have specific img_url
        if (notification.notificationCategoryDTO.name === 'Play with Celebrity') return this.getTranslations.project_celebrity_img;
        return notification.opponentAvatar;
      }
      return notification.notificationCategoryDTO.imgUrl;
    },
    numberOfUnreadNotifications() {
      // comment next line for dev purpose
      this.userNotifications = this.notifications;
      this.unreadNotifications = (this.userNotifications) ? this.userNotifications.filter(notification => !notification.readStatus).length : 0;
    },
    getButtonTranslation(text) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === text)[0];
      if (notification) {
        return this.getTranslations[notification.notificationButtonTranslation];
      }
      return this.getTranslations[(this.getTranslationsKeys.filter(key => key === 'home_notifications_check_it')).toString()];
    },
    notificationsWithoutCheckItButton(name) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === name)[0];
      let notificationWithButton = true;
      if (notification) {
        notificationWithButton = notification.notificationButtonTranslation ? notification.notificationButtonTranslation : false;
      }
      return notificationWithButton;
    },
    notificationTranslationMethodText(notificationData) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.value === notificationData.notificationCategoryDTO.value)[0];
      if (notification) {
        if (notification.text === this.getNotificationsNames.CelebrityNotification.text) return this.getTranslations[notificationData.text];
        let textBefore = notification.notificationTextBeforeTranslation || '';
        if (textBefore) {
          textBefore = this.getTranslations[textBefore];
        }
        let textAfter = notification.notificationTextAfterTranslation || '';
        if (textAfter) {
          textAfter = this.getTranslations[textAfter];
        }
        if (notification.dynamicText) {
          if (!textBefore && !textAfter) return '';
          return `${textBefore} ${moment(notificationData.startDate).format('LLL')} ${textAfter} ${moment(notificationData.endDate).format('LLL')}`;
        } else if (notification.profileLink) {
          return `${textBefore} <a href="#" class="profileLink">${notificationData.text}</a> ${textAfter}`;
        }
        return `${textBefore} ${notificationData.text} ${textAfter}`;
      }
      return this.getTranslations[notificationData.text];
    },
    notificationTranslationMethod(text) {
      /* eslint-disable */
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === text)[0];
      if(notification) text = notification.notificationTitleTranslation;
      return this.getTranslations[text];
      /* eslint-enable */
    },
    displayMore() {
      this.moreNotifications = true;
      this.extraArrays = [];
      this.displayBlackBar = [];
    },
    checkItToday(notification) {
      this.currentNotificationData = notification;
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        if (this.userNotifications[i].id === notification.id && !this.checkIfNotificationIsOfType(this.userNotifications[i], /PendingSpinningWheelGame|PendingLootBoxGame|PendingLightTheLanternsGame|PendingPuzzleGame|Achievement/g)) {
          this.userNotifications[i].readStatus = true;
          break;
        }
      }
      this.sendNotificationIdtoDB(notification);
    },
    checkIt(notification) {
      this.currentNotificationData = notification;
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        if (this.displayDifferentDaysNotifications[i].data.id === notification.id && !this.checkIfNotificationIsOfType(this.userNotifications[i], /PendingSpinningWheelGame|PendingLootBoxGame|PendingLightTheLanternsGame|PendingPuzzleGame|Achievement/g)) {
          this.displayDifferentDaysNotifications[i].data.readStatus = true;
          break;
        }
      }
      this.sendNotificationIdtoDB(notification);
    },
    checkIfNotificationIsOfType(notification, typeRegex) {
      return typeRegex.test(notification.notificationCategoryDTO.value);
    },
    sendNotificationIdtoDB(notificationIdtoDB) {
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.CelebrityNotification.text) {
        this.checkGameValidationsForCelebrity(); // play with celebrity
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.BonusPhasesDaily.text) {
        const modalData = {
          quantity: notificationIdtoDB.bonusPoints,
          loginStreak: notificationIdtoDB.gamesEarned,
          dailyBonusType: notificationIdtoDB.gameType,
        };
        this.saveBonusDailyModal(modalData);
        this.storeModalForHomePage(BonusDaily);
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.LevelUp.text) {
        // eslint-disable-next-line
        const notificationLevelupData = {
          userLevel: notificationIdtoDB.userLevel,
          bonusPoints: notificationIdtoDB.bonusPoints,
          gamesEarned: notificationIdtoDB.gamesEarned,
        };
        // temp
        this.setShowmodalForLevelUp({ notificationLevelupObject: notificationLevelupData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.TopRanking.text) {
        const notificationRankingData = {
          userLevel: notificationIdtoDB.userLevel,
          bonusPoints: notificationIdtoDB.bonusPoints,
          gamesEarned: notificationIdtoDB.gamesEarned,
        };
        // temp
        this.setShowmodalForRanking({ notificationRankingObject: notificationRankingData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.MonthlyPrize.text ||
        notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.WeeklyPrize.text || notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.DailyPrize.text) {
        if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.MonthlyPrize.text) {
          const notificationPrizeDetailsData = this.getMonthlyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        } else if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.WeeklyPrize.text) {
          const notificationPrizeDetailsData = this.getWeeklyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        } else if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.DailyPrize.text) {
          const notificationPrizeDetailsData = this.getDailyPrize;
          this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
        }
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.GrandPrize.text) {
        const notificationPrizeDetailsData = this.getGrandPrize;
        // temp
        this.setShowmodalForDefaultPrizeDetails({ notificationPrizeDetailsObject: notificationPrizeDetailsData });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.ChangeUsernameOrPin.text) {
        this.$router.push('profile');
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.VerifyEmail.text) {
        this.$router.push('profile/edit');
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.OneGamePlayed.text) {
        this.$router.push('home');
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.NotEnoughBalance.text) {
        this.$router.push('store');
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.OfflineUser.text) {
        this.updateChallengeInfo({
          challengedLevel: notificationIdtoDB.opponentLevel,
          challengingLevel: this.userDetails.level,
          challengedMsisdn: null,
          challengingMsisdn: this.userDetails.msisdn,
          challengedUsername: notificationIdtoDB.text,
          challengingUsername: this.userDetails.username,
          challengedAvatar: notificationIdtoDB.opponentAvatar,
          challengingAvatar: this.userDetails.avatar,
        });
        this.storeModalForHomePage(ConfirmChallengeRequest);
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.SpinWheel.text) {
        this.setCheckedNotificationId({ value: notificationIdtoDB.id });
        this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
        this.setNotificationRewardId({ value: '' });
        this.setNotificationRewardName({ value: notificationIdtoDB.text });
        this.setNotificationPrizeWon({ value: notificationIdtoDB.hasWon });
        this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.LootBox.text) {
        this.setCheckedNotificationId({ value: notificationIdtoDB.id });
        this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
        this.setNotificationRewardId({ value: '' });
        this.setNotificationRewardName({ value: notificationIdtoDB.text });
        this.setNotificationPrizeWon({ value: notificationIdtoDB.hasWon });
        this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.BundleDiscount.text ||
        notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.BonusPointsPhase.text) {
        let modal;
        switch (notificationIdtoDB.notificationCategoryDTO.name) {
        case 'Bonus Points Phase':
          modal = PointsMultiplier;
          break;
        case 'Bundle Discount':
          modal = BundleDiscount;
          break;
        default:
          modal = null;
          break;
        }
        const modalData = {
          start: notificationIdtoDB.startDate,
          end: notificationIdtoDB.endDate,
          multiplier: notificationIdtoDB.text,
        };
        this.updatePhaseBonusModalToBeDisplayed(modalData);
        this.storeModalForHomePage(modal);
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.Achievement.text) {
        this.setCheckedNotificationId({ value: notificationIdtoDB.id });
        this.setCheckedNotificationReadStatus({ value: notificationIdtoDB.readStatus });
        this.setNotificationRewardId({ value: notificationIdtoDB.gameId });
      }
      if (notificationIdtoDB.notificationCategoryDTO.name === this.getNotificationsNames.InvitationRegistration.text) {
        this.updateChallengeInfo({
          challengedLevel: notificationIdtoDB.opponentLevel,
          challengingLevel: this.userDetails.level,
          challengedMsisdn: null,
          challengingMsisdn: this.userDetails.msisdn,
          challengedUsername: notificationIdtoDB.text,
          challengingUsername: this.userDetails.username,
          challengedAvatar: notificationIdtoDB.opponentAvatar,
          challengingAvatar: this.userDetails.avatar,
        });
        this.storeModalForHomePage(ConfirmChallengeRequest);
      }
      this.showModalMethod(notificationIdtoDB.notificationCategoryDTO.name);
    },
    showModalMethod(notificationModalName) {
      const notification = Object.values(this.getNotificationsNames).filter(key => key.text === notificationModalName)[0];
      if (notification) {
        if (notification.showModal) {
          this.currentNotificationModal = notification.showModal;
        }
      }
    },
    clearData() {
      this.clearNotifications().then(() => {
        this.displayNotifications = [];
        this.displayDifferentDaysNotifications = [];
        this.displayBlackBar = [];
        this.extraArrays = [];
        this.showmore = false;
        this.userNotifications = [];
        this.unreadNotifications = 0;
      });
    },
    hasTheSameDate(notificationDate1, notificationDate2) {
      return (moment(notificationDate1).format('L') === moment(notificationDate2).format('L'));
    },
  },
  computed: {
    ...mapState('profile', [
      'notifications',
      'jwtInVuex',
      'achievements',
      'checkedNotificationId',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('common', [
      'getNotificationsNames',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationsKeys',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGrandPrize',
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
    ]),
    currentProperties() {
      if (this.currentNotificationModal === 'NewAchievement') {
        const { text } = this.currentNotificationData;

        const achievementData = this.achievements
          .flatMap(a => a.achievementDTOs)
          .flatMap(ad => ad.achievementLevelDTOs.map(l => ({ ...l, category: ad.achievementName })))
          .filter(al => `${al.category}_${al.achievementLevelName}` === text)[0];

        // eslint-disable-next-line
        const { category, prizeValue, prizeType, awardedPrizeDesc, awardedCorrelationId } = achievementData;

        this.setNotificationRewardName({ value: awardedPrizeDesc });
        this.setNotificationPrizeWon({ value: !!awardedCorrelationId });

        return {
          achievementInfo: {
            achievementLevelName: text.replace(`${category}_`, ''),
            image: `static/images/achievements_cat/${category.toLowerCase()}.png`,
            prizeValue,
            prizeType,
            categoryName: category,
          },
        };
      }
      return null;
    },
    extraArraysLength() {
      return this.showmore;
    },
    notificationTodayArrays() {
      /* eslint-disable */
      this.displayNotifications = [];
      this.displayDifferentDaysNotifications = [];
      this.displayBlackBar = [];
      for (let i = 0; i < this.userNotifications.length; i += 1) {
        this.displayNotifications.push(this.userNotifications[i]);
      }
      for (let i = this.userNotifications.length - 1; i >= 0; i--) {
        if (moment(this.userNotifications[i].notificationDate).format('L') === (moment(Date.now()).format('L'))) {
          delete this.displayNotifications[i];
        }
      }
      this.displayNotifications = this.displayNotifications.filter(function (e) {  //delete null values
        return e
      });
      for (let i = 0; i < this.displayNotifications.length; i += 1) {
        if (i === 0) {
          let first = {
            id: this.displayNotifications[i].notificationDate,
            data: this.displayNotifications[i],
          };
          this.displayDifferentDaysNotifications.push(first);
        }
        else {
          let notific = {
            id: '',
            data: '',
          };
          for (let k = 0; k < this.displayDifferentDaysNotifications.length; k += 1) {
            if (moment(this.displayNotifications[i].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[k].data.notificationDate).format('L')) {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
              break;
            }
            else {
              notific = {
                id: this.displayNotifications[i].notificationDate,
                data: this.displayNotifications[i],
              };
            }
          }
          this.displayDifferentDaysNotifications.push(notific);
        }
      }
      return this.userNotifications.filter(function (notification) {
        return moment(notification.notificationDate).format('L') === moment(Date.now()).format('L');
      });
    },
    notificationArraysBar() { //notifications from the same date have the same notificationDate
      for (let i = 0; i < this.displayDifferentDaysNotifications.length; i += 1) {
        let notific = {
          id: '',
          notificationDate: '',
        };
        if (i === 0) {
          let first = {
            id: this.displayDifferentDaysNotifications.length - 1,
            notificationDate: this.displayDifferentDaysNotifications[i].data.notificationDate,
          };
          this.displayBlackBar.push(first);
        }
        else {
          let isAlreadyinArray = false;
          for (let k = 0; k < this.displayBlackBar.length; k += 1) {
            isAlreadyinArray = false;
            if (moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L')) {
              break;
            }
            else {
              if (!(moment(this.displayBlackBar[k].notificationDate).format('L') === moment(this.displayDifferentDaysNotifications[i].id).format('L'))) {
                isAlreadyinArray = true;
                notific.id = k;
                notific.notificationDate = this.displayDifferentDaysNotifications[i].data.notificationDate;
              }
            }
          }
          if (isAlreadyinArray) {
            this.displayBlackBar.push(notific);
          }
        }
      }
      this.displayBlackBar.sort(
        (a, b) => b.notificationDate - a.notificationDate,
      );
      this.showmore = false;
      if ((this.displayBlackBar.length > this.hiddenNotificationsNumber) && this.moreNotifications === false) {
        this.showmore = true;
        for (let k = this.hiddenNotificationsNumber; k < this.displayBlackBar.length; k += 1) {
          this.extraArrays.push(this.displayBlackBar[k]);
          delete this.displayBlackBar[k];
        }
      }
      this.displayBlackBar = this.displayBlackBar.filter(function (e) {  //delete null values
        return e
      });
      return this.displayBlackBar;
      /* eslint-enable */
    },
    notificationArrays() {
      return this.displayDifferentDaysNotifications;
    },
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getFormatForBar(dateInBar) {
      return moment(dateInBar).format('LL');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Notifications.vue